module.exports = __webpack_public_path__ + "img/4_91.4a0ac6d5.png";